type Listener = () => void;

let activeCount = 0;
const listeners = new Set<Listener>();

const notify = () => listeners.forEach((listener) => listener());

/**
 * Marks the global loader as needed. Returns a release function.
 * Ref-counted so overlapping loading gates keep the single loader
 * DOM node visible without unmounting it (which would restart the
 * CSS stroke-draw animation).
 */
export const acquireLoader = (): (() => void) => {
  activeCount += 1;
  notify();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeCount -= 1;
    notify();
  };
};

export const subscribeLoader = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const isLoaderVisible = (): boolean => activeCount > 0;
